<template>
    <audio id="audio" autoplay>
        <source :src="audioSrc" type="audio/mp3">
    </audio>
</template>

<script>
export default {

    name: 'AudioMedium',

    props: {
        source: String,
        lang: String
    },

    data() {
        return {
            bChangedLang: false,
            ration: 0,
            audioSrc: ''
        }
    },

    watch: {
        source(val) {

            this.audioSrc = val;

        },

        lang(newval, oldval) {

            console.info(newval, oldval);

            this.bChangedLang = true;

            let audio = document.getElementById('audio');

            let currentTime = audio.currentTime;
            let totalDuration = audio.duration;
            this.ratio = currentTime / totalDuration;

            this.audioSrc = this.audioSrc.replace(/\/(en|fr|ch|pt|ru|it|es|nl|jp|pt)\//, '/'+ newval +'/');
            console.info(this.audioSrc);

        },

        audioSrc(val) {

            let self = this;

            let audio = document.getElementById('audio');

            audio.load();
            audio.addEventListener('canplay', () => {
                if (self.bChangedLang) {
                    audio.currentTime = Math.round(audio.duration * self.ratio);
                    self.bChangedLang = false;
                }
                audio.play();
            });

        }
    },

    mounted() {

        let that = this;

        document.getElementById('audio').addEventListener('ended', function() {
            that.onAudioEnd();
        });

    },

    methods: {
        onAudioEnd() {
            this.$emit('endplay');
        }
    }


}
</script>

<style lang="css" scoped>
</style>